import React from 'react';

const TermsConditions = () => {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last Updated: January 2024</p>

        <section>
          <h2>1. Agreement to Terms</h2>
          <p>
            Welcome to Fitness Health Blog ("Company," "we," "our," or "us"). These Terms and Conditions ("Terms") govern your access to and use of our website topfitnessproducts.com and the purchase of our premium fitness and health products, including supplements, equipment, and accessories.
          </p>
          <p>
            By accessing or using our website, creating an account, or making a purchase, you agree to be bound by these Terms and all applicable laws and regulations. If you do not agree with any part of these Terms, you must not use our website or services.
          </p>
          <p>
            These Terms constitute a legally binding agreement between you and Fitness Health Blog. Please read them carefully before using our services.
          </p>
        </section>

        <section>
          <h2>2. Definitions</h2>
          <p>For the purposes of these Terms:</p>
          <ul>
            <li><strong>"Website"</strong> refers to topfitnessproducts.com and all associated pages and services</li>
            <li><strong>"Services"</strong> refers to all products, content, features, and services offered through our website</li>
            <li><strong>"Products"</strong> refers to fitness and health items available for purchase, including protein powder, supplements, yoga mats, resistance bands, fitness trackers, water bottles, and related accessories</li>
            <li><strong>"User," "you," or "your"</strong> refers to any individual or entity using our website or services</li>
            <li><strong>"Account"</strong> refers to the user profile created for accessing certain features</li>
            <li><strong>"Content"</strong> refers to all text, images, videos, reviews, and other materials on our website</li>
          </ul>
        </section>

        <section>
          <h2>3. Eligibility and Account Registration</h2>
          
          <h3>3.1 Age Requirements</h3>
          <p>
            You must be at least 18 years of age to use our website and purchase products. By using our services, you represent and warrant that you meet this age requirement. Certain products may have additional age restrictions, which will be clearly indicated.
          </p>

          <h3>3.2 Account Creation</h3>
          <p>
            To access certain features and make purchases, you may need to create an account. When creating an account, you agree to:
          </p>
          <ul>
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain and promptly update your account information</li>
            <li>Keep your password secure and confidential</li>
            <li>Accept responsibility for all activities under your account</li>
            <li>Notify us immediately of any unauthorized access or security breach</li>
          </ul>

          <h3>3.3 Account Termination</h3>
          <p>
            We reserve the right to suspend or terminate your account at any time, with or without notice, for violations of these Terms, fraudulent activity, or any other reason we deem appropriate. You may also close your account at any time by contacting customer service.
          </p>
        </section>

        <section>
          <h2>4. Product Information and Availability</h2>
          
          <h3>4.1 Product Descriptions</h3>
          <p>
            We make every effort to provide accurate product descriptions, images, pricing, and availability information. However, we do not warrant that product descriptions, colors, specifications, or other content are accurate, complete, reliable, current, or error-free.
          </p>

          <h3>4.2 Product Categories</h3>
          <p>Our products include but are not limited to:</p>
          <ul>
            <li>Nutritional supplements (protein powder, vitamins, pre-workout, etc.)</li>
            <li>Fitness equipment (resistance bands, dumbbells, kettlebells, etc.)</li>
            <li>Yoga and Pilates accessories (mats, blocks, straps, etc.)</li>
            <li>Wearable fitness technology (fitness trackers, heart rate monitors, etc.)</li>
            <li>Hydration products (water bottles, shaker bottles, etc.)</li>
            <li>Apparel and accessories</li>
          </ul>

          <h3>4.3 Availability and Modifications</h3>
          <p>
            Product availability is subject to change without notice. We reserve the right to:
          </p>
          <ul>
            <li>Limit quantities of products available for purchase</li>
            <li>Discontinue products at any time</li>
            <li>Modify product specifications, formulations, or packaging</li>
            <li>Refuse orders that exceed reasonable purchase quantities</li>
            <li>Correct pricing errors or inaccuracies</li>
          </ul>

          <h3>4.4 Health and Safety Information</h3>
          <p>
            Supplements and nutritional products are not intended to diagnose, treat, cure, or prevent any disease. Always consult with a healthcare professional before starting any supplement regimen, especially if you have pre-existing medical conditions or are taking medications.
          </p>
        </section>

        <section>
          <h2>5. Pricing and Payments</h2>
          
          <h3>5.1 Pricing</h3>
          <p>
            All prices are listed in GBP (£) and are subject to change without notice. Prices include applicable taxes unless otherwise stated. We reserve the right to correct pricing errors and may cancel orders placed at incorrect prices.
          </p>

          <h3>5.2 Payment Methods</h3>
          <p>
            We accept various payment methods, including:
          </p>
          <ul>
            <li>Credit cards (Visa, Mastercard, American Express)</li>
            <li>Debit cards</li>
            <li>PayPal</li>
            <li>Other payment processors as indicated at checkout</li>
          </ul>

          <h3>5.3 Payment Processing</h3>
          <p>
            Payment is processed at the time of order placement. By providing payment information, you authorize us to charge the total amount, including products, shipping, and applicable taxes. You represent that you have the legal right to use the payment method provided.
          </p>

          <h3>5.4 Promotional Codes and Discounts</h3>
          <p>
            Promotional codes and discounts are subject to specific terms and conditions, including expiration dates and usage limitations. Codes cannot be combined unless explicitly stated and have no cash value. We reserve the right to modify or cancel promotions at any time.
          </p>
        </section>

        <section>
          <h2>6. Orders and Order Acceptance</h2>
          
          <h3>6.1 Order Placement</h3>
          <p>
            When you place an order through our website, you are making an offer to purchase products subject to these Terms. All orders are subject to acceptance by us. We may refuse or cancel any order for any reason, including:
          </p>
          <ul>
            <li>Product unavailability</li>
            <li>Pricing or product description errors</li>
            <li>Suspected fraudulent activity</li>
            <li>Payment authorization issues</li>
            <li>Violations of these Terms</li>
          </ul>

          <h3>6.2 Order Confirmation</h3>
          <p>
            You will receive an email confirmation when your order is placed. This confirmation does not constitute acceptance of your order. Acceptance occurs when we ship the products and send you a shipping confirmation email.
          </p>

          <h3>6.3 Order Modifications and Cancellations</h3>
          <p>
            Once an order is placed, modifications may not be possible. To request order cancellation, contact customer service immediately at +448648285526. We cannot guarantee cancellation if the order has already been processed or shipped.
          </p>
        </section>

        <section>
          <h2>7. Shipping and Delivery</h2>
          
          <h3>7.1 Shipping Methods</h3>
          <p>
            We offer various shipping options at checkout. Shipping times and costs vary based on destination, shipping method, and order size. Delivery estimates are approximate and not guaranteed.
          </p>

          <h3>7.2 Shipping Address</h3>
          <p>
            You are responsible for providing accurate shipping information. We are not liable for delays or non-delivery caused by incorrect or incomplete addresses. Please verify your shipping address before completing your order.
          </p>

          <h3>7.3 Delivery</h3>
          <p>
            Risk of loss and title for products pass to you upon delivery to the carrier. We are not responsible for delays caused by shipping carriers, customs clearance, weather conditions, or other circumstances beyond our control.
          </p>

          <h3>7.4 International Shipping</h3>
          <p>
            International orders may be subject to import duties, taxes, and customs fees, which are the responsibility of the recipient. Delivery times for international orders vary and may be affected by customs processing.
          </p>

          <h3>7.5 Failed Deliveries</h3>
          <p>
            If a package is returned to us due to failed delivery, incorrect address, or refusal to accept, you may be responsible for reshipping costs. Contact customer service to arrange redelivery.
          </p>
        </section>

        <section>
          <h2>8. Returns and Refunds</h2>
          <p>
            Returns and refunds are governed by our Refund Policy, which is incorporated into these Terms by reference. Please review our Refund Policy for detailed information about:
          </p>
          <ul>
            <li>Eligible products for return</li>
            <li>Return timeframes and conditions</li>
            <li>Refund processing procedures</li>
            <li>Non-returnable items</li>
            <li>Damaged or defective products</li>
          </ul>
          <p>
            Our Refund Policy is available on our website and can be accessed at any time. By making a purchase, you acknowledge that you have read and agree to the Refund Policy.
          </p>
        </section>

        <section>
          <h2>9. Intellectual Property Rights</h2>
          
          <h3>9.1 Ownership</h3>
          <p>
            All content on our website, including text, graphics, logos, images, videos, software, and compilation, is the property of Fitness Health Blog or our licensors and is protected by copyright, trademark, and other intellectual property laws.
          </p>

          <h3>9.2 Limited License</h3>
          <p>
            We grant you a limited, non-exclusive, non-transferable license to access and use our website for personal, non-commercial purposes. You may not:
          </p>
          <ul>
            <li>Reproduce, distribute, or publicly display our content without permission</li>
            <li>Modify, create derivative works, or reverse engineer our website</li>
            <li>Use our content for commercial purposes</li>
            <li>Remove copyright or proprietary notices</li>
            <li>Use automated systems (bots, scrapers) to access our website</li>
          </ul>

          <h3>9.3 Trademarks</h3>
          <p>
            "Fitness Health Blog" and our logo are trademarks owned by us. Other trademarks, service marks, and trade names appearing on our website are the property of their respective owners. You may not use any trademarks without prior written permission.
          </p>

          <h3>9.4 User-Generated Content</h3>
          <p>
            By submitting reviews, comments, photos, or other content to our website, you grant us a worldwide, royalty-free, perpetual, irrevocable license to use, reproduce, modify, adapt, publish, and display such content for any purpose.
          </p>
        </section>

        <section>
          <h2>10. User Conduct and Prohibited Activities</h2>
          <p>
            You agree not to engage in any of the following prohibited activities:
          </p>
          <ul>
            <li>Violating any applicable laws or regulations</li>
            <li>Infringing on intellectual property rights</li>
            <li>Transmitting harmful code, viruses, or malware</li>
            <li>Attempting to gain unauthorized access to our systems</li>
            <li>Harassing, threatening, or defaming others</li>
            <li>Posting false, misleading, or fraudulent content</li>
            <li>Impersonating others or misrepresenting affiliations</li>
            <li>Collecting user information without consent</li>
            <li>Interfering with website functionality or security</li>
            <li>Using our website for unauthorized commercial purposes</li>
            <li>Submitting fake reviews or manipulating ratings</li>
            <li>Reselling products for commercial gain without authorization</li>
          </ul>
        </section>

        <section>
          <h2>11. Product Warranties and Disclaimers</h2>
          
          <h3>11.1 Product Warranties</h3>
          <p>
            Products are covered by manufacturer warranties where applicable. We will assist in facilitating warranty claims for defective products. Warranty terms vary by product and manufacturer.
          </p>

          <h3>11.2 Disclaimer of Warranties</h3>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR WEBSITE AND PRODUCTS ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
          </p>
          <ul>
            <li>Warranties of merchantability</li>
            <li>Fitness for a particular purpose</li>
            <li>Non-infringement</li>
            <li>Accuracy, reliability, or completeness of content</li>
            <li>Uninterrupted or error-free operation</li>
          </ul>

          <h3>11.3 Health and Fitness Disclaimers</h3>
          <p>
            Our products and content are not intended to replace professional medical advice. Results may vary based on individual factors. We make no guarantees regarding weight loss, muscle gain, performance improvement, or other health outcomes. Always consult healthcare professionals before starting new fitness or supplement programs.
          </p>
        </section>

        <section>
          <h2>12. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, FITNESS HEALTH BLOG AND ITS OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS SHALL NOT BE LIABLE FOR:
          </p>
          <ul>
            <li>Indirect, incidental, special, consequential, or punitive damages</li>
            <li>Loss of profits, revenue, data, or business opportunities</li>
            <li>Personal injury or property damage resulting from product use</li>
            <li>Errors or omissions in content or product information</li>
            <li>Unauthorized access to or alteration of your data</li>
            <li>Third-party conduct or content</li>
            <li>Website downtime or technical issues</li>
          </ul>
          <p>
            OUR TOTAL LIABILITY FOR ANY CLAIM ARISING FROM YOUR USE OF OUR WEBSITE OR PRODUCTS SHALL NOT EXCEED THE AMOUNT YOU PAID FOR THE PRODUCT IN QUESTION, OR £100, WHICHEVER IS LESS.
          </p>
          <p>
            Some jurisdictions do not allow the exclusion or limitation of certain warranties or liabilities. In such jurisdictions, our liability is limited to the maximum extent permitted by law.
          </p>
        </section>

        <section>
          <h2>13. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless Fitness Health Blog and its affiliates, officers, directors, employees, agents, and licensors from any claims, liabilities, damages, losses, costs, or expenses (including reasonable attorneys' fees) arising from:
          </p>
          <ul>
            <li>Your use of our website or products</li>
            <li>Your violation of these Terms</li>
            <li>Your violation of any rights of third parties</li>
            <li>Your user-generated content</li>
            <li>Your fraudulent or illegal activities</li>
          </ul>
        </section>

        <section>
          <h2>14. Privacy and Data Protection</h2>
          <p>
            Your use of our website is also governed by our Privacy Policy, which describes how we collect, use, and protect your personal information. By using our services, you consent to our data practices as described in the Privacy Policy.
          </p>
          <p>
            We are committed to protecting your privacy in accordance with applicable data protection laws, including GDPR and UK data protection regulations.
          </p>
        </section>

        <section>
          <h2>15. Third-Party Links and Services</h2>
          <p>
            Our website may contain links to third-party websites, services, or resources. These links are provided for your convenience only. We do not endorse, control, or assume responsibility for third-party content, products, services, or practices.
          </p>
          <p>
            Your interactions with third parties, including payment processors, social media platforms, and advertisers, are solely between you and the third party. We are not liable for any damages or losses arising from such interactions.
          </p>
        </section>

        <section>
          <h2>16. Dispute Resolution</h2>
          
          <h3>16.1 Governing Law</h3>
          <p>
            These Terms are governed by and construed in accordance with the laws of England and Wales, without regard to conflict of law principles.
          </p>

          <h3>16.2 Jurisdiction</h3>
          <p>
            Any disputes arising from these Terms or your use of our website shall be subject to the exclusive jurisdiction of the courts of England and Wales. Our business address is:
          </p>
          <div className="contact-details">
            <p>Studio 52 Kennedy Grove South Wendy</p>
            <p>London, NW2 2SH</p>
            <p>United Kingdom</p>
          </div>

          <h3>16.3 Informal Resolution</h3>
          <p>
            Before filing any formal dispute, you agree to contact us at +448648285526 to attempt to resolve the matter informally. We will make good faith efforts to resolve disputes amicably.
          </p>

          <h3>16.4 Arbitration</h3>
          <p>
            If informal resolution fails, disputes may be subject to binding arbitration in accordance with the rules of the London Court of International Arbitration (LCIA). The arbitration shall take place in London, England, and be conducted in English.
          </p>
        </section>

        <section>
          <h2>17. Modifications to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to our website with an updated "Last Updated" date. Material changes will be communicated through:
          </p>
          <ul>
            <li>Prominent notice on our website homepage</li>
            <li>Email notification to registered users</li>
            <li>In-app notifications where applicable</li>
          </ul>
          <p>
            Your continued use of our website after changes are posted constitutes acceptance of the modified Terms. If you do not agree to the changes, you must discontinue use of our services.
          </p>
        </section>

        <section>
          <h2>18. Termination</h2>
          <p>
            We may terminate or suspend your access to our website immediately, without prior notice or liability, for any reason, including:
          </p>
          <ul>
            <li>Breach of these Terms</li>
            <li>Fraudulent or illegal activity</li>
            <li>Request by law enforcement</li>
            <li>Prolonged inactivity</li>
            <li>Technical or security reasons</li>
          </ul>
          <p>
            Upon termination, your right to use our website ceases immediately. Provisions that by their nature should survive termination shall survive, including ownership, warranty disclaimers, indemnification, and limitations of liability.
          </p>
        </section>

        <section>
          <h2>19. Severability</h2>
          <p>
            If any provision of these Terms is found to be invalid, illegal, or unenforceable by a court of competent jurisdiction, such provision shall be modified to the minimum extent necessary to make it enforceable, or if modification is not possible, it shall be severed from these Terms. The remaining provisions shall continue in full force and effect.
          </p>
        </section>

        <section>
          <h2>20. Entire Agreement</h2>
          <p>
            These Terms, together with our Privacy Policy and Refund Policy, constitute the entire agreement between you and Fitness Health Blog regarding your use of our website and supersede all prior agreements, understandings, and communications, whether written or oral.
          </p>
        </section>

        <section>
          <h2>21. Waiver</h2>
          <p>
            Our failure to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision. No waiver shall be effective unless made in writing and signed by an authorized representative of Fitness Health Blog.
          </p>
        </section>

        <section>
          <h2>22. Assignment</h2>
          <p>
            You may not assign or transfer these Terms or your rights hereunder without our prior written consent. We may assign or transfer these Terms, in whole or in part, without restriction, including to affiliates or in connection with a merger, acquisition, or sale of assets.
          </p>
        </section>

        <section>
          <h2>23. Contact Information</h2>
          <p>
            If you have questions, concerns, or feedback regarding these Terms, please contact us:
          </p>
          
          <div className="contact-details">
            <p><strong>Fitness Health Blog</strong></p>
            <p>Studio 52 Kennedy Grove South Wendy</p>
            <p>London, NW2 2SH</p>
            <p>United Kingdom</p>
            <p>Phone: +448648285526</p>
            <p>Email: support@topfitnessproducts.com</p>
            <p>Website: https://topfitnessproducts.com</p>
          </div>

          <p>
            Customer service hours: Monday - Friday, 9:00 AM - 6:00 PM GMT
          </p>
        </section>

        <section>
          <h2>24. Acknowledgment</h2>
          <p>
            BY USING OUR WEBSITE AND SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS AND CONDITIONS.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;